<script setup>
  import { ref, computed, watchEffect, useTemplateRef} from 'vue';
    import { useMediaQuery } from '@/composables/useMediaQuery';

  import Icon from './icons/Icon.vue';

  const props = defineProps({
    value: {
      type: String,
      required: true
    },
    iconName: {
      type: String,
      required: true
    },
    position: {
      type: Object,
      required: true
    },
    graph: {
      type: [Object, null],
      required: true
    }
  });

  const markerLabel = useTemplateRef('marker-label');


    const isDesktop = useMediaQuery('(min-width: 840px)');

  const markerPosition = ref({ x: 0, y: 0 });
  const graph = ref(props.graph)

  const labelStyle = computed(() => {
    return {
      position: 'absolute',
      left: `${labelXPosition.value}px`,
      top: `${markerPosition.value.y}px`,
    };
  });

  const labelXPosition = computed(() => {
    if (!markerLabel.value) return markerPosition.value.x || 0;

    const offsetWidth = markerLabel.value.offsetWidth / 2;
    const toolTipLeftEdge = markerPosition.value.x - offsetWidth;
    const toolTipRightEdge = markerPosition.value.x + offsetWidth;
    const edgePadding = 8;
    let clampedX = markerPosition.value.x + props.graph.plotLeft;

    if (toolTipLeftEdge < props.graph.plotLeft) {
      clampedX = props.graph.plotLeft + offsetWidth + edgePadding;
    } else if (toolTipRightEdge > props.graph.plotWidth - props.graph.plotLeft) {
      clampedX = props.graph.plotWidth - edgePadding;
    }

    return clampedX;
  });  

  watchEffect(() => {
    if (props.position) {
      markerPosition.value = props.position;
    }
  });
</script>

<template>
  <Teleport :to="graph.container">
    <div
      ref="marker-label"
      class="jwx-tide-graph__event-value-label"
      :style="labelStyle"
    >
      <div class="jwx-tide-graph__event-label-icon">
        <Icon :name="props.iconName" class="jwx-tide-graph__event-label-icon" />
      </div>
      {{ props.value }}
    </div>
  </Teleport>
</template>